import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { isRtl } from '@ugc-utils/utils';
import { getReview } from '@ugc-api/review';
import { modalZIndex } from '@ugc-utils/modal-z-index';
import { Arrow } from '../../../icons';
import { getReviewImagesDataByPageNumber, toSingleReviewInfo } from '@ugc-components/ugc-pdp-review/utils';

@Component({
  tag: 'ugc-review-dt-all-images-modal',
  styleUrl: 'ugc-review-dt-all-images-modal.scss',
  shadow: false,
})
export class UgcReviewDtAllImagesModal {
  async handleClickPagination(pageNumber) {
    const {
      dtAllCustomerImagesData,
      dtAllImagesPagination: { pages },
    } = state;
    if (pageNumber < 1 || pageNumber > pages) return;
    if (!dtAllCustomerImagesData[pageNumber]) {
      const items = await getReviewImagesDataByPageNumber(pageNumber);
      state.dtAllCustomerImagesData = {
        [pageNumber]: items,
      };
    }
    state.dtAllImagesPagination = {
      current: pageNumber,
      pages,
    };
  }

  async onClickImage(assetId) {
    const {
      dtAllCustomerImagesData,
      dtAllImagesPagination: { current },
    } = state;
    try {
      if (dtAllCustomerImagesData[current]) {
        const filterImage = dtAllCustomerImagesData[current].find(image => image.assetId === assetId);
        if (filterImage) {
          const { reviewId } = filterImage;
          state.activeImageReviewId = reviewId;
          state.activeImageAssetId = assetId;
          const data = (await getReview(state.activeImageReviewId)) || {};
          state.customerImagesDetailModalData = toSingleReviewInfo(data);
          state.isShowCustomerAllImagesDetailModal = true;
        }
      }
    } catch (e) {}
  }

  handleCancel() {
    state.isShowCustomerImagesModal = false;
  }

  render() {
    const {
      reviewStaticLanguage: { IDS_LBL_REVIEW_IMAGES = '' },
      dtAllCustomerImagesData,
      dtAllImagesPagination: { current, pages },
      isShowCustomerImagesModal,
    } = state;
    const maxShowPage = 7;
    let basePage = 1;
    let pageList = [];

    if (pages > maxShowPage) {
      if (current >= maxShowPage && current !== pages) {
        basePage = current - 3;
      }
      if (current + maxShowPage > pages) {
        basePage = pages - 7;
      }
      if ((pages - 1) / 2 === current) {
        basePage = current - 3;
      }

      // set page
      if (current - maxShowPage > 0 && current + maxShowPage < pages) {
        pageList = new Array(maxShowPage).fill(current - 3).map((_current, index) => _current + index);
      } else {
        pageList = new Array(pages > maxShowPage ? maxShowPage : pages)
          .fill(basePage)
          .map((_current, index) => _current + index);
      }
      if (
        pages > maxShowPage &&
        ((current >= maxShowPage && current !== pages) || current + maxShowPage >= pages) &&
        current - 3 >= 1
      ) {
        pageList.unshift(null);
        pageList.unshift(1);
      }
      if (pages > maxShowPage || current > pages - maxShowPage) {
        if (current <= pages - maxShowPage) {
          pageList.push(null);
        }
        pageList.push(pages);
      }
    } else {
      pageList = new Array(pages).fill(basePage).map((_current, index) => _current + index);
    }

    const renderImageList =
      dtAllCustomerImagesData[current] &&
      dtAllCustomerImagesData[current].map(({ assetId, paths: { m = '' } = {} }) => (
        <div
          class="ugc-review-image flex-row-center-center pointer"
          key={assetId}
          onClick={this.onClickImage.bind(this, assetId)}
        >
          <img src={m} alt="image" />
        </div>
      ));

    const renderPagenation = pageList.map(pageNumber => (
      <p
        class={`py-8 px-16 pointer fs-14 bold bg-gray-200 rounded-6 flex-row-center-center ${
          current === pageNumber ? 'active color-white bg-green-dark' : 'c-333'
        }`}
        onClick={this.handleClickPagination.bind(this, pageNumber)}
      >
        {pageNumber === null ? '...' : pageNumber}
      </p>
    ));

    return (
      <ugc-modal-dialog
        isShow={isShowCustomerImagesModal}
        modalTitle={`${IDS_LBL_REVIEW_IMAGES}`}
        rootStyle={{ width: '800px' }}
        handleCancel={this.handleCancel.bind(this)}
        zIndex={modalZIndex['ugc-review-dt-all-images-modal']}
      >
        {isShowCustomerImagesModal && (
          <div class="ugc-review-dt-all-images-modal-wrap px-32 pb-24">
            <div class="ugc-customer-images-list flex-row-start-start flex-wrap gap-4">{renderImageList}</div>
            <div class="mt-24 flex-row-center-center gap-8">
              <div
                class="flex-row-center-center pointer bg-gray-200 rounded-6 p-8"
                style={{ transform: isRtl() ? 'rotate(-90deg)' : 'rotate(-270deg)' }}
                onClick={this.handleClickPagination.bind(this, current - 1)}
              >
                <Arrow width="20" height="20" />
              </div>
              <div class="pointer flex-row-center-center gap-8">{renderPagenation}</div>
              <div
                class="flex-row-center-center pointer bg-gray-200 rounded-6 p-8"
                style={{ transform: isRtl() ? 'rotate(-270deg)' : 'rotate(-90deg)' }}
                onClick={this.handleClickPagination.bind(this, current + 1)}
              >
                <Arrow width="20" height="20" />
              </div>
            </div>
          </div>
        )}
      </ugc-modal-dialog>
    );
  }
}
